"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'chat.noCredits.message': 'Non hai abbastanza crediti per utilizzare il servizio di chat. Acquista più crediti per continuare.',
};
